import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PricingListComponent } from './pricing-list/pricing-list.component';

const routes: Routes = [
  {
    path: '',
    component: PricingListComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PricingRoutingModule {}
